export function getListingList(data) {
    return new Promise((resolve, reject) => {
		let { getListingListRequest, getListingListError, getListingListResult } = this.props;

		this.doAction(
			this.WEB_REQUEST_URL + 'get_listing_list',
			this.createBundle(
				'get_listing_list',
				{ listing: data },
				this.GET,
				getListingListRequest,
                (result) => {
                    getListingListResult(result)
                    resolve(result)
                },
                (error) => {
                    getListingListError(error)
                    reject(error)
                }
			)
		);
	})
}
